import React, { useState } from "react";
import ReceivePaymentMethod from "./ReceivePaymentMethod";

const ReceivePayments = (props) => {
  return <ReceivePaymentMethod {...props} />;
};

export default ReceivePayments;
